<ng-container *transloco="let t">
    <app-admin-modal-layout
            [title]="'leagues.copy.modal.title'"
            [saveDisabled]="inputForm.invalid"
            (onSave)="onSaveButtonClick()"
            (onClose)="onClose()"
    >
        <div class="pb-4">
            <form [formGroup]="inputForm">
                <div class="row">
                    <div class="col-12 pb-3">
                        <app-language-input [inputForm]="inputForm"
                                            [defaultLanguage]="league?.defaultLanguage"
                                            [extraLanguages]="league?.extraLanguages" [hrKey]="'name'"
                                            [enKey]="'nameEng'"
                                            [srKey]="'nameSr'"
                                            [bsKey]="'nameBs'"
                                            [itKey]="'nameIta'" [siKey]="'nameSlo'" [hrLabel]="'event.item.nameCro'"
                                            [enLabel]="'event.item.nameEn'" [bsLabel]="'event.item.nameBs'" [srLabel]="'event.item.nameSr'" [itLabel]="'event.item.nameIt'"
                                            [siLabel]="'event.item.nameSlo'"/>
                    </div>
                </div>
                <div class="row">
                        <div class="col-xl-6">
                            <app-date-time-input formControlName="start" [displayTime]="true"
                                                 [label]="t('league.details.start.date')"
                                                 [maxDate]="inputForm.controls['end'].value">
                            </app-date-time-input>
                        </div>
                        <div class="col-xl-6">
                            <app-date-time-input formControlName="end" [displayTime]="true"
                                                 [label]="t('league.details.end.date')"
                                                 [minDate]="inputForm.controls['start'].value">
                            </app-date-time-input>
                        </div>
                </div>

            </form>
        </div>
    </app-admin-modal-layout>
</ng-container>
